import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogContractCreate } from './dialog';

@NgModule({
  declarations: [
    DialogContractCreate
  ],
  imports: [
    CommonModule
  ], exports: [
    DialogContractCreate
  ]
})
export class DialogContractCreateModule { }
